import { Table } from '@mantine/core';

interface TableHeaderProps {
  isSmallScreen: boolean;
  sortBy: 'name' | 'last_seen' | null;
  sortDirection: 'asc' | 'desc';
  onSort: (field: 'name' | 'last_seen') => void;
}

export const TableHeader = ({ isSmallScreen, sortBy, sortDirection, onSort }: TableHeaderProps) => {
  return (
    <Table.Thead>
      <Table.Tr>
        <Table.Th 
          style={{ cursor: 'pointer' }}
          onClick={() => onSort('name')}
        >
          Name {sortBy === 'name' && (sortDirection === 'asc' ? '↑' : '↓')}
        </Table.Th>
        {!isSmallScreen && <Table.Th>MAC Address</Table.Th>}
        <Table.Th>IP Address</Table.Th>
        <Table.Th 
          style={{ cursor: 'pointer' }}
          onClick={() => onSort('last_seen')}
        >
          Last Seen {sortBy === 'last_seen' && (sortDirection === 'asc' ? '↑' : '↓')}
        </Table.Th>
        {!isSmallScreen && <Table.Th>Tags</Table.Th>}
        {!isSmallScreen && <Table.Th>Additional Info</Table.Th>}
      </Table.Tr>
    </Table.Thead>
  );
};